// Lý do Gỡ xe / Hủy ghép — sync với BE enum CONTRACT_UNALLOCATE_REASON
// (backend/src/common/enum/contract.enum.ts). Value lowercase_snake.

export const CONTRACT_UNALLOCATE_REASON = {
  PRIORITY_OVER_7D: 'priority_over_7d',
  VEHICLE_DEFECT: 'vehicle_defect',
  CUSTOMER_CHANGE: 'customer_change',
  STOCK_REALLOCATION: 'stock_reallocation',
  OTHER: 'other',
  // Chỉ do CRON tự động sinh — hiển thị được ở lịch sử HĐ, KHÔNG cho chọn tay.
  AUTO_RELEASE_7D: 'auto_release_7d',
};

export const CONTRACT_UNALLOCATE_REASON_LABEL = {
  [CONTRACT_UNALLOCATE_REASON.PRIORITY_OVER_7D]:
    'Ưu tiên KH khác (quá 7 ngày chưa xuất hóa đơn)',
  [CONTRACT_UNALLOCATE_REASON.VEHICLE_DEFECT]: 'Xe lỗi / vấn đề kỹ thuật',
  [CONTRACT_UNALLOCATE_REASON.CUSTOMER_CHANGE]: 'Khách đổi nhu cầu xe / màu',
  [CONTRACT_UNALLOCATE_REASON.STOCK_REALLOCATION]: 'Điều phối tồn kho',
  [CONTRACT_UNALLOCATE_REASON.OTHER]: 'Khác',
  [CONTRACT_UNALLOCATE_REASON.AUTO_RELEASE_7D]:
    'Tự động nhả kho (quá 7 ngày chưa xuất hóa đơn)',
};

// Lý do CHỌN TAY trong modal Gỡ xe — loại AUTO_RELEASE_7D (chỉ CRON sinh ra).
// Giữ nguyên shape phần tử `{ value, text }` vì modal Gỡ xe đang bind theo shape này.
export const CONTRACT_UNALLOCATE_REASON_OPTIONS = Object.values(
  CONTRACT_UNALLOCATE_REASON,
)
  .filter((value) => value !== CONTRACT_UNALLOCATE_REASON.AUTO_RELEASE_7D)
  .map((value) => ({ value, text: CONTRACT_UNALLOCATE_REASON_LABEL[value] }));
